import { useState, useCallback } from 'react';

export const useBooleanState = (initialValue?: boolean) => {
  const [value, setValue] = useState(initialValue ?? false);
  const setTrue = useCallback(() => setValue(true), [setValue]);
  const setFalse = useCallback(() => setValue(false), [setValue]);

  return { value, setTrue, setFalse, setValue };
};
